<template>
  <div class="page-container">
    <!-- Header -->
    <header class="header-section">
      <div class="flex items-center">
        <!-- Logo -->
        <img src="@/assets/icon_logo_top.png" alt="Abit Game" class="h-8 md:h-12" />
      </div>
      <div class="flex items-center gap-6">
        <div class="header-phone">
           <svg class="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
           <span>+852 65896001</span>
        </div>
        <button class="btn-contact">
          Contact
        </button>
      </div>
    </header>

    <!-- Hero Section -->
    <section class="section-hero" :style="heroBgStyle">
      <!-- Background glow effects -->
      <div class="bg-glow-left"></div>
      <div class="bg-glow-right"></div>

      <div class="hero-content">
        <div class="hero-text-block">
          <h1 class="hero-title">
            Unleash Non <br/>
            -Stop Fun
          </h1>
          <p class="hero-subtitle">Instantly Become an Insider Player gathering point</p>
          
          <!-- <div class="flex justify-center md:justify-start">
            <button class="btn-download">
              <svg class="w-8 h-8" viewBox="0 0 24 24" fill="currentColor"><path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.74 1.18 0 2.45-1.64 3.98-1.54 2.35.13 3.54 1.63 4.15 2.53-4.1 2.5-3.4 8.79 1.8 11.24-.05.15-.3.84-.96 1.84M12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/></svg>
              <span class="text-left text-xl font-bold ml-2">App Store</span>
            </button>
          </div> -->
        </div>
      </div>
    </section>

    <!-- Phone Showcase Section -->
    <section class="section-showcase" :style="phoneBgStyle">
      <div class="container mx-auto px-6 text-center">
        <!-- Phone Image as background, same处理方式 as hero -->

        
        <h2 class="showcase-title">
          Join The Fun And Watch Your <br> Favorite Shows Today!
        </h2>
      </div>
    </section>

    <!-- Footer / Download Section -->
    <section class="section-footer" :style="footerBgStyle">
       <!-- Background Image/Glow -->
      <div class="footer-bg-image">
         <img src="@/assets/img_page_03.png" class="w-full h-full object-cover object-bottom opacity-50 mix-blend-screen" />
      </div>
       <div class="footer-bg-gradient"></div>

      <div class="container mx-auto px-6 text-center">
        <p class="text-gray-300 mb-4 text-lg">Install now</p>
        <h2 class="footer-title">
          Don't Miss Out <br/>
          on The Fun
        </h2>
        
         <!-- <button class="btn-download mx-auto mb-6">
            <svg class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.74 1.18 0 2.45-1.64 3.98-1.54 2.35.13 3.54 1.63 4.15 2.53-4.1 2.5-3.4 8.79 1.8 11.24-.05.15-.3.84-.96 1.84M12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/></svg>
            <span class="text-left">
              <span class="block text-xs">Download on the</span>
              <span class="block text-lg leading-none">App Store</span>
            </span>
          </button> -->
          
          <!-- 协议入口：用户协议 / 隐私政策 -->
          <div class="footer-links">
            <a href="https://aboxapp.com/useragreement.html" target="_blank" rel="noopener noreferrer">用户协议</a>
            <span class="footer-links-separator">|</span>
            <a href="https://aboxapp.com/privacypolicy.html" target="_blank" rel="noopener noreferrer">隐私政策</a>
          </div>
          
          <div class="footer-contact">
            <div class="contact-item">
              <img src="@/assets/icon_page4_mail.png" class="contact-icon" />
              <span>AbitGamemax@gmail.com</span>
            </div>
             <div class="contact-item">
               <img src="@/assets/icon_page4_gs.png" class="contact-icon" />
              <span>Hong Kong EasyPoint Technology Limited</span>
            </div>
             <div class="contact-item">
               <img src="@/assets/icon_page4_map.png" class="contact-icon shrink-0" />
              <span>Room D07, 8/F, Kai Tak Factory Building Phase ll, 99 King Fuk Street,San Po Kong, Hong Kong</span>
            </div>
          </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import heroBg from '@/assets/img_top_01@2x.png'
import phoneImg from '@/assets/img_page_02.png'
import footerBg from '@/assets/img_page_03@2x.png'

const heroBgStyle = {
  backgroundImage: `url(${heroBg})`,
  backgroundPosition: 'right center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat'
}

const phoneBgStyle = {
  backgroundImage: `url(${phoneImg})`,
  backgroundPosition: 'center center',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat'
}
const footerBgStyle = {
  backgroundImage: `url(${footerBg})`,
  backgroundPosition: 'center center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat'
}

</script>

<style>
@import "tailwindcss";

@theme {
  --color-brand-dark: #0f0c29;
  --color-brand-purple: #302b63;
  --color-brand-blue: #24243e;
}

/* 流体文字：随视口自适应 */
:root {
  /* 主标题固定为 64px（4rem），和 UI 一致 */
  --fluid-hero-title: 8rem;
  --fluid-hero-subtitle: clamp(0.875rem, 1.2vw + 0.6rem, 1.25rem);
  --fluid-section-title: 7rem;
  --fluid-footer-title: clamp(1.75rem, 4.5vw + 0.5rem, 3.75rem);
  --fluid-body: clamp(0.75rem, 1vw + 0.5rem, 0.875rem);
  --fluid-btn: clamp(0.875rem, 1vw + 0.5rem, 1rem);
  --fluid-contact: clamp(0.625rem, 0.8vw + 0.4rem, 0.75rem);
  --section-padding-x: 4%;
  --section-padding-y: 5%;
  --header-padding-x: 4%;
}

/* Base */
.page-container {
  min-height: 100vh;
  background-color: #050511;
  color: white;
  font-family: inherit;
  overflow-x: hidden;
  box-sizing: border-box;
}

.page-container *,
.page-container *::before,
.page-container *::after {
  box-sizing: border-box;
}

/* Header - 百分比内边距 */
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 30;
  width: 100%;
  padding: clamp(0.75rem, 2vw, 1.25rem) var(--header-padding-x);
}

.header-section img {
  height: clamp(1.5rem, 4vw, 3rem);
  width: auto;
  max-width: 100%;
}

.header-phone {
  display: none;
  align-items: center;
  gap: 0.5rem;
  font-size: var(--fluid-body);
  color: rgb(209 213 219);
  font-weight: 500;
}

@media (min-width: 768px) {
  .header-phone {
    display: flex;
  }
}

.header-phone svg {
  width: clamp(1rem, 2vw, 1.25rem);
  height: clamp(1rem, 2vw, 1.25rem);
  flex-shrink: 0;
}

.btn-contact {
  /* 顶部 Contact 按钮：白底黑字 */
  background: white;
  color: black;
  padding: clamp(0.5rem, 1.5vw, 0.75rem) clamp(1rem, 3vw, 2rem);
  border-radius: 0.75rem;
  font-size: var(--fluid-btn);
  font-weight: 700;
  transition: background 0.2s;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.btn-contact:hover {
  background: rgb(229 231 235);
}

/* Hero Section - 百分比布局 */
.section-hero {
  position: relative;
  min-height: 90vh;
  padding-top: clamp(6rem, 15vw, 8rem);
  padding-bottom: clamp(4rem, 10vw, 8rem);
  overflow: hidden;
  display: flex;
  align-items: center;
}

@media (min-width: 768px) {
  .section-hero {
    min-height: 100vh;
  }
}

.bg-glow-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -10;
  opacity: 0.3;
  background: linear-gradient(135deg, rgba(88, 28, 135, 0.25) 0%, transparent 50%);
}

.bg-glow-right {
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  z-index: -10;
  opacity: 0.15;
  background: radial-gradient(ellipse at right, rgba(59, 130, 246, 0.2), transparent 70%);
}

.hero-content {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 var(--section-padding-x);
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: clamp(2rem, 5vw, 4rem);
}

@media (min-width: 768px) {
  .hero-content {
    grid-template-columns: 1fr 1fr;
  }
}

.hero-title {
  font-size: var(--fluid-hero-title);
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 0.5em;
}

.hero-text-block {
  display: flex;
  flex-direction: column;
  gap: clamp(1rem, 2.5vw, 1.5rem);
  z-index: 10;
  text-align: center;
  margin-top: clamp(2rem, 8vw, 6rem);
}

@media (min-width: 768px) {
  .hero-text-block {
    text-align: left;
  }
}

.hero-text-block .flex {
  margin-top: clamp(0.5rem, 2vw, 1.5rem);
}

.hero-subtitle {
  color: rgb(209 213 219);
  font-size: var(--fluid-hero-subtitle);
  line-height: 1.6;
  max-width: 90%;
}

@media (min-width: 768px) {
  .hero-subtitle {
    max-width: 28em;
  }
}

/* 按钮 - 自适应 */
.btn-download {
  /* 苹果商店按钮：白底黑字 */
  background: white;
  color: black;
  display: inline-flex;
  align-items: center;
  gap: clamp(0.5rem, 1.5vw, 0.75rem);
  padding: clamp(0.75rem, 2vw, 1rem) clamp(1rem, 4vw, 2rem);
  border-radius: 1rem;
  font-size: var(--fluid-btn);
  font-weight: 700;
  transition: background 0.2s;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.btn-download:hover {
  background: rgb(229 231 235);
}

.btn-download svg {
  width: clamp(1.25rem, 3vw, 2rem);
  height: clamp(1.25rem, 3vw, 2rem);
  color: black;
  flex-shrink: 0;
}

.btn-download .ml-2 {
  margin-left: 0.5rem;
}

.section-footer .btn-download {
  padding: clamp(0.75rem, 2vw, 1rem) clamp(1.5rem, 4vw, 2rem);
}

/* Showcase Section - 百分比 */
.section-showcase {
  height: 80rem;
  padding: clamp(4rem, 10vw, 6rem) 0;
  margin-top: 10rem;
  position: relative;
  background: #050511;
}

.section-showcase .container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 var(--section-padding-x);
  text-align: center;
}

.phone-wrapper {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: min(320px, 60vw);
  aspect-ratio: 9 / 19;
  position: relative;
  z-index: 10;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.showcase-title {  
  position: absolute;
  top: 80rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: var(--fluid-section-title);
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  width: 100%;
}

/* Animations */
.floating-icon {
  position: absolute;
  animation: bounce 3s ease-in-out infinite;
}

.icon-thumb {
  top: 10%;
  left: clamp(-2rem, -5vw, -6rem);
  animation-duration: 3s;
}

.icon-kiss {
  top: 20%;
  right: clamp(-2rem, -5vw, -6rem);
  animation-duration: 4s;
  animation-delay: 0.7s;
}

.icon-heart {
  bottom: 30%;
  left: clamp(-2rem, -5vw, -7rem);
  animation-duration: 3.5s;
  animation-delay: 0.2s;
}

.icon-chat {
  bottom: 40%;
  right: clamp(-2rem, -5vw, -7rem);
  animation-duration: 4.5s;
  animation-delay: 0.5s;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}

/* Footer - 百分比 */
.section-footer {
  margin-top: 20rem;
  padding-top: clamp(4rem, 10vw, 6rem);
  padding-bottom: clamp(2rem, 5vw, 3rem);
  position: relative;
  overflow: hidden;
}

.section-footer .container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 var(--section-padding-x);
  text-align: center;
}

.footer-bg-image {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 800px;
  max-height: 80vh;
  opacity: 0.3;
  z-index: -10;
}

.footer-bg-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: bottom;
  opacity: 0.5;
  mix-blend-mode: screen;
}

.footer-bg-gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -10;
  background: linear-gradient(to top, #050511, transparent 50%, transparent);
}

.section-footer p.text-gray-300 {
  color: rgb(209 213 219);
  margin-bottom: 0.5rem;
  font-size: var(--fluid-hero-subtitle);
}

.footer-title {
  font-size: var(--fluid-footer-title);
  font-weight: 700;
  margin-bottom: clamp(2rem, 4vw, 3rem);
  line-height: 1.2;
}

.footer-contact {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(1rem, 3vw, 1.5rem);
  font-size: var(--fluid-contact);
  color: rgb(156 163 175);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: clamp(2rem, 4vw, 2.5rem);
  max-width: 95%;
  margin-left: auto;
  margin-right: auto;
}

.footer-links {
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
  font-size: var(--fluid-contact);
  color: rgb(156 163 175);
}

.footer-links a {
  color: inherit;
  text-decoration: none;
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-links-separator {
  margin: 0 0.5rem;
}

@media (min-width: 768px) {
  .footer-contact {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 56rem;
  }
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.contact-icon {
  width: 1rem;
  height: 1rem;
  max-width: clamp(0.875rem, 1.5vw, 1rem);
  max-height: clamp(0.875rem, 1.5vw, 1rem);
  object-fit: contain;
  flex-shrink: 0;
}
</style>
